//Ultima HTML5 Landing Page v2.3
//Copyright 2014 8Guild.com
//All scripts for Ultima Landing Page version #1

/*Page Preloading*/
$(window).load(function () {
    //$('#spinner').fadeOut();
    $('#preloader').delay(300).fadeOut('slow');
    setTimeout(function () {
        $('.first-slide div:first-child').addClass('fadeInDown');
    }, 100);
    setTimeout(function () {
        $('.first-slide div:last-child').addClass('fadeInRight');
    }, 100);
    setTimeout(function () {
        $('#top-navi').addClass('bounceInDown');
    }, 100);
    setTimeout(function () {
        $('.side-navi').addClass('slideInRight');
    }, 100);
});

/*Document Ready*/
$(document).ready(function (e) {
    $("#registration_form").submit(function () {
        $("#register_button").attr("disabled", true);
        return true;
    });
    /*Vertically Center Side Navigation*/
    var sideNav = $('.side-navi');
    var sideNavH = sideNav.innerHeight();
    var sideNavMT = -sideNavH / 2;
    $('.side-navi').css('margin-top', sideNavMT);

    ////////////////////////////////////////////////////////////
    //INTERNAL ANCHOR LINKS SCROLLING (NAVIGATION)

    $(".scroll").click(function (event) {
       // event.preventDefault();
       // var hash = $(this).attr('href');
       // $('html, body').animate({scrollTop: $(hash).offset().top}, 1000, 'easeInOutQuart');
    });

    //SCROLL-SPY
    // Cache selectors
    var lastId,
            topMenu = $(".side-navi"),
            topMenuHeight = topMenu.outerHeight(),
            // All list items
            menuItems = topMenu.find("a");
    // Anchors corresponding to menu items


    var scrollItems = menuItems.map(function () {
        var item = $($(this).attr('href'));
        if (item.length) {
            return item;
        }
    });

    // Bind to scroll
    $(window).scroll(function () {
        if ($('#is_mobile').val() === '0') {
            var offset = $('[name="registration"]').offset().top;
            if ($(this).scrollTop() > 500 && $(this).scrollTop() < (offset - 50)) {
                $('#join-now').addClass('visible');
            } else {
                $('#join-now').removeClass('visible');
            }
        }
        // Get container scroll position
        var fromTop = $(this).scrollTop() + topMenuHeight;

        // Get id of current scroll item
        var cur = scrollItems.map(function () {
            if ($(this).offset().top < fromTop) {

                return this;
            }
        });
        // Get the id of the current element
        cur = cur[cur.length - 1];

        var id = cur && cur.length ? cur[0].id : "";

        if (lastId !== id) {//console.log('lastId',menuItems,'menuItems');
            lastId = id;
            // Set/remove active class
            //console.log(menuItems.parent(),'menuItems.parent()', menuItems.end().filter("[href=#" + id + "]"));
            menuItems
                    .parent().removeClass("current").end();
            
            menuItems.filter("[href=#" + id + "]").parent().addClass("current");
        }

    });
    ////////////////////////////////////////////////////////////////////

    /*Tooltips*/
    $('.tooltipped').tooltip();

    /*Subscriptions Form Validation*/
    $('.subscribe-form').validate();
    var shareButtons = document.querySelectorAll(".st-custom-button[data-network]");
    for (var i = 0; i < shareButtons.length; i++) {
        var shareButton = shareButtons[i];
        shareButton.addEventListener("click", function (e) {
            var elm = e.target;
            var network = elm.dataset.network;
        });
    }
    $('#media').DataTable({
        "paging": false,
        "searching": false,
        "ordering": false,
        "info": false,
        "scrollY": '340px',
        "scrollCollapse": true,
        "lengthChange": true,
        "autoWidth": true,
        "scrollX": true
    });
    $(".carousel-inner").swipe({
        //Generic swipe handler for all directions
        swipeRight: function (event, direction, distance, duration, fingerCount) {
            $(this).parent().carousel('prev');
        },
        swipeLeft: function () {
            $(this).parent().carousel('next');
        },
        //Default is 75px, set to 0 for demo so any distance triggers swipe
        threshold: 0
    });
    $('.carousel').carousel({
        interval: 1000 * 5
    });

    /**
     * START Magnify infographics
     */
    const magnifier = document.getElementById('infographics-slider-magnifier');
    if (magnifier) {
        const $carousel = $('#infographics-slider');

        function onMagnifierClick(e) {
            if (
                    e.target.classList.contains('carousel-control')
                    || e.target.classList.contains('glyphicon')
                    ) {
                return;
            }

            const isActive = magnifier.classList.contains('active');
            if (!isActive) {
                $carousel.carousel('pause');
                magnifier.classList.add('active');
            } else {
                magnifier.classList.remove('active');
                $carousel.carousel('cycle');
            }
        }
        magnifier.addEventListener('click', onMagnifierClick);
    }
    /**
     * END Magnify infographics
     */

    /**
     * START Header
     */
    const headerContent = document.getElementById('eyes-on-alz-content');
    const headerToggle = document.getElementById('eyes-on-alz-toggle');
    headerToggle.addEventListener('click', function () {
        headerContent.classList.toggle('collapsed');
    });
    /**
     * END Header
     */

    /**
     * START Molecules
     */
    // Subscribe form
    document.addEventListener('submit', function (e) {
        if (e.target.classList.contains('subscribe-form')) {
            window.setTimeout(function () {
                e.target.EMAIL.value = '';
            }, 0);
        }
    })
    /**
     * END Molecules
     */
    var target = window.location.hash,
            target = target.replace('#', '');
    window.location.hash = "";
    $(window).on('load', function () {
        if (target) {
            $('html, body').animate({
                scrollTop: $('#' + target).offset().top
            }, 700, 'swing', function () {});
        }
    });
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            $('#blog_element').html('<a href="https://blog.eyesonalz.com" target="_blank"><img width="100%" class="img-responsive" src="images/landing/blog.jpg" /></a>' +
                    '<div style="width:100%; height:150px;">' +
                    '<object id="blog_object" type="text/html" data="https://blog.eyesonalz.com#content" style="width:100%; height:100%;">' +
                    '</object></div>');
        } else {
            $('#blog_element').html('<a href="https://blog.eyesonalz.com" target="_blank"><img width="100%" class="img-responsive" src="images/landing/blog3.jpg" /></a>');
        }
    } else {
        $('#blog_element').html('<a href="https://blog.eyesonalz.com" target="_blank"><img width="100%" class="img-responsive" src="images/landing/blog.jpg" /></a>' +
                '<div style="width:100%; height:150px;">' +
                '<object id="blog_object" type="text/html" data="https://blog.eyesonalz.com#content" style="width:100%; height:100%;">' +
                '</object></div>');
    }
    var player = videojs('#topSectionPlayer'); //Videojs object
    player.on("waiting", function ()
    {
        this.addClass("vjs-custom-waiting");
    });
    player.on("playing", function ()
    {
        this.removeClass("vjs-custom-waiting");
    });
    $('#topSectionPlayer').css("display", "block");
});